/*
 * @Author: duck
 * @Date: 2023-03-30 19:47:47
 * @LastEditors: duck
 * @LastEditTime: 2023-04-16 11:11:27
 * @Description: file content
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Plugins from '@/plugins'
import { Lazyload } from 'vant'
import PrimeVue from 'primevue/config'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import Paginator from 'primevue/paginator'
import Calendar from 'primevue/calendar'
import MultiSelect from 'primevue/multiselect'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import VueClipboard from 'vue-clipboard2'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import messages from 'vee-validate/dist/locale/en.json'

import 'vant/lib/index.css'
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
// import 'primeicons/primeicons.css '

Vue.use(PrimeVue)
Vue.use(VueClipboard)
Vue.use(Lazyload)
Vue.use(Plugins)

Vue.component('DataTable', DataTable)
Vue.component('Column', Column)
Vue.component('ColumnGroup', ColumnGroup)
Vue.component('Paginator', Paginator)
Vue.component('Calendar', Calendar)
Vue.component('MultiSelect', MultiSelect)
Vue.component('Dropdown', Dropdown)
Vue.component('InputText', InputText)
Vue.component('InputNumber', InputNumber)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Object.keys(rules).forEach((rule) => {
	extend(rule, {
		...rules[rule], // copies rule configuration
		message: messages[rule] // assign message
	})
})

Object.keys(rules).forEach((rule) => {
	extend(rule, rules[rule])
})

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app')
